
  import {Component, Vue} from 'vue-property-decorator';
  import {IApp} from "@/interfaces/app.interface";
  import type {IParksConfig} from "@/modules/ParksConfig/interfaces/parks-config.interface";
  import AppThCell from "@/shared/AppTable/components/AppThCell.vue";
  import {IAppTable} from "@/shared/AppTable/interfaces/sort-table-data";

  @Component({
    components: {
      AppThCell,
    }
  })
  export default class ParksTable extends Vue {
    propType = IApp.SortingPropType;

    get tableList(): IParksConfig.IPark[] { return this.$store.getters['parksConfig/sortedList'].array; }
    get sortingData(): IAppTable.ISortingData { return this.$store.state.parksConfig.sortingTable; }
    get dataProps(): IAppTable.ITableProp[] {
      return [
        { label: 'Код',             prop: 'id',          propType: IApp.SortingPropType.Number, },
        { label: 'Наименование',    prop: 'parkName',    propType: IApp.SortingPropType.String, actionClick: this.openParkEvents },
      ];
    }

    async cellClick(cell: IAppTable.ITableProp, item: any) {
      if (cell.actionClick) {
        await cell.actionClick(item);
      }
    }

    setSorting(cell: IAppTable.ITableProp) {
      this.$store.commit('parksConfig/setSorting', cell);
    }

    async openParkEvents(park: IParksConfig.IPark) {
      await this.$store.dispatch('dialog/openDialog', {
        blockName: 'parksConfig',
        dialogName: 'parkEvents',
        payload: { park },
      });
    }
  }
